module.exports = __webpack_public_path__ + "img/ff69290.png";